import { Form } from '@ant-design/compatible'

import ManageProducerForm from './ManageProducerForm'

export default Form.create({
  name: 'producerForm',
})(ManageProducerForm)
